import { XMarkIcon } from "@heroicons/react/20/solid";
import { Button } from "../../Catalyst/button";
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from "../../Catalyst/dialog";

// Support request modal with the embedded Tally form.
const SupportDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => (
  <Dialog size="5xl" open={open} onClose={onClose}>
    <div className="flex justify-between items-center">
      <div>
        <DialogTitle>Support</DialogTitle>
        <DialogDescription>
          Please fill out the form below and we'll get back to you as soon as possible.
        </DialogDescription>
      </div>
      <Button
        plain
        onClick={onClose}
        className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-gray-100 transition-colors"
        title="Close"
      >
        <XMarkIcon className="w-5 h-5 text-gray-500" />
      </Button>
    </div>
    <DialogBody className="p-0">
      <div className="w-full h-[650px] overflow-hidden">
        <iframe
          src="https://tally.so/embed/wgkQ8K?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
          width="100%"
          height="100%"
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
          title="Support Form"
          className="border-none"
          style={{ margin: 0, padding: 0, overflow: "hidden" }}
        />
      </div>
    </DialogBody>
    <DialogActions>
      <Button outline onClick={onClose}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default SupportDialog;
